import { render, staticRenderFns } from "./OpsTable.vue?vue&type=template&id=051ae3a5&"
import script from "./OpsTable.vue?vue&type=script&lang=js&"
export * from "./OpsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports